// Import dependencies
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

// Import escapeHTML
import { escapeHTML } from '@wordpress/escape-html';

// Import i18n functions
import { __ } from '@wordpress/i18n';

@customElement('uap-builder-magic-trigger-shortcode')
export class AutomatorBuilderMagicTriggerShortcode extends LitElement {
	
	/**
	 * The full sentence from the trigger.
	 *
	 * @type {string}
	 */
	@property({ type: String })
	accessor sentence = '';
	
	/**
	 * The id of the trigger item.
	 * 
	 * @type {number}
	 */
	@property({ type: Number, attribute: 'item-id' })
	accessor itemId = 0;
	
	/**
	 * The trigger code.
	 * 
	 * @type {string}
	 */
	@property({ type: String, attribute: 'item-code' })
	accessor itemCode = '';
	
	/**
	 * Render in light DOM to allow field copy to work.
	 * 
	 * @returns {Element} The render root.
	 */
	createRenderRoot() {
		return this;
	}
	
	/**
	 * Render the shortcode copy button.
	 * 
	 * @returns {TemplateResult} The template result.
	 */
	render() {
		return html`
			<uo-click-to-copy
				content-name="${this.labelText}"
				tooltip="${this.tooltip}"
				.getContent="${() => this.shortcode}"
			></uo-click-to-copy>
		`;
	}
	
	/**
	 * Get the id of the shortcode.
	 * 
	 * @returns {string} The id of the shortcode.
	 */
	get id() {
		return `uap-magic-button-shortcode-${this.itemId}`;
	}

	/**
	 * Get the shortcode from the sentence.
	 * 
	 * @returns {string} The shortcode.
	 */
	get shortcode() {
		// Extract the shortcode from the sentence.
		let shortcode = this.sentence.match( /\[(.*?)\]/g )[ 0 ];
		return shortcode.length > 0 ? shortcode.replace( /\\/g, '' ) : '';
	}

	/**
	 * Check if the trigger is a link trigger.
	 * 
	 * @returns {boolean} True if the trigger is a link trigger, false otherwise.
	 */
	get isLinkTrigger() {
		return ['WPMAGICLINK', 'ANONWPMAGICLINK'].includes(this.itemCode);
	}

	/**
	 * Get the label text.
	 * 
	 * @returns {string} The label text.
	 */
	get labelText() {
		return this.isLinkTrigger
			? escapeHTML( __('Magic link shortcode', 'uncanny-automator') )
			: escapeHTML( __('Magic button shortcode', 'uncanny-automator') );
	}

	/**
	 * Get the tooltip text.
	 * 
	 * @returns {string} The tooltip text.
	 */
	get tooltip() {
		return this.isLinkTrigger
			? escapeHTML( __('Copy magic link shortcode', 'uncanny-automator') )
			: escapeHTML( __('Copy magic button shortcode', 'uncanny-automator') );
	}
}